import { render } from "./App.vue?vue&type=template&id=32a37fc5&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=32a37fc5&lang=scss"

import exportComponent from "/data/landun/workspace/passport.ctp.qq.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__